var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal',{attrs:{"to":"layout-default-header"}},[_c('header-edit',{attrs:{"title":_vm.group.name}})],1),_c('side-nav-router-view',{attrs:{"nav-items":_vm.navItems,"group":_vm.group}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }